import { FC } from "react"
import { FilesManager } from "../../../../module/settings/containers/files/manager"

export const FilesManagerPage: FC = () => <FilesManager />
